<template>
	<div>
		<indexHeader ref="indexHeader"></indexHeader>

		<div class="check load_inLeft">
			<!--<div class="status" v-if="state == 2">-->
			<!--<img src="/static/images/error.png" width="192px" height="174px">-->
			<!--<h3>未完成规定学时暂不允许考试</h3>-->
			<!--<p>请您完成3学时学习内容后再来参加考试</p>-->
			<!--<a href="/module/index.html" class="back">返回首页</a>-->
			<!--</div>-->
			<div class="status">
				<!-- <img src="/static/images/pass.png" width="160px" height="160px"> -->
				<h3>支付金额明细</h3>
				<p v-show="pxje"><span>行政处罚培训：</span><i>￥{{pxje}}</i></p>
				<!--  <p v-show="xybgje != 0"><span>信用报告（元）：</span><i>￥{{xybgje}}</i></p>
		    <div v-if="cfxx.length && xybgje &&!!cfxx[0].cfwh&&!!cfxx[0].cfrq" class="bg_lin">
				<div v-for="(item,index) in cfxx" class="bg_box" :key="index">
					<div class="left">
						<span>处罚文号：</span><i>{{item.cfwh}}</i>
					</div>

					<div class="right">
						<span>处罚时间：</span><i>{{item.cfrq}}</i>
					</div>
				</div>
		    </div> -->
				<div class="item_name_title"><span style="color: red;">*</span>本次需要出具报告的处罚条数：{{punishList.length}}条 <div style="padding-left: .3rem;"><div  @click="handleAdd" class="add">增加</div></div></div>
				<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="100px">
					<div v-for="(item,index) in punishList" :key="index">
						<div  class="box_item">
							<span style="width: 110px;"><span style="color: red;">*</span>处罚文号</span>
							<el-input v-model="item.punish" placeholder="请填写处罚文号"></el-input>
							<img @click="handleDle(index)" style="cursor: pointer;" v-show="index > 0" src="../../../static/images/del.png" alt="">
						</div>
					</div>

				</el-form>
				<p class="color_line"><span>合计（元）：</span><i>￥{{money}}</i></p>
				<img src="/static/images/zfb.png" style="margin-top: 40px">
				<div class="alipay" @click="alipay()">点击去支付</div>
				<div class="pay_to">
					<!-- <el-radio size="medium" label="1">备选项<router-link to="/">协议内容</router-link></el-radio> -->
					<el-checkbox v-model="rad" label="我已阅读并同意" name="type"></el-checkbox>
					<router-link class="pay_link" to="/xy" target="_blank">《 服务协议 》</router-link>

				</div>
				<router-link to="/" class="back">返回首页</router-link>
				<!--<div class="join">参加考试</div>-->
			</div>
		</div>

		<indexFooter></indexFooter>
	</div>

</template>

<script>
	import { cookie } from "@/common/js/cookies.js";
	import indexHeader from "@/components/index/index_header";
	import indexFooter from "@/components/index/index_footer";
export default {
  name: "index_dzf",
  data() {
    return {
      pxje: "",
      xybgje: "",
      zje: "",
      cfxx:[],
	  money:'',
	  //是否阅读协议
    rad: true,
    punishList:[{punish:''}],
    qyId: null,
	 ruleForm: {
	          punish: '',
	        },
			rules: {
			          punish: [
			            { required: true, message: '请输入处罚文号', trigger: 'blur' },
			          ],
					 }

    };
  },
  mounted() {
    // 自动跳转流程
    let { sign } = this.$route.query;
    if (sign == 1) {
      let NEXT_DO_OBJ = JSON.parse(localStorage.getItem("NEXT_DO_OBJ"));
      this.lxId = NEXT_DO_OBJ.lxId;
      this.qyId = NEXT_DO_OBJ.qyId;
      // 赋值后删除
      // localStorage.removeItem("NEXT_DO_OBJ");
    }else{
      this.lxId = this.$route.query.lxid;
      this.qyId = this.$route.query.id;
    }
    // console.log(this.$route.query.id);
    document.getElementsByClassName("header")[0].style.background = "#fff";
    this.getData();
  },
	components: {
	  indexHeader,
	  indexFooter
	},
  methods: {
	  // 添加处罚文号
	  handleAdd(){
	  	this.punishList.push({
	  		punish:'',
	  	})
	  	
	  	if(this.punishList.length <= 1){
	  		this.money = this.accAdd(this.pxje,800)
	  	}else if(this.punishList.length > 1 &&this.punishList.length <6 ){
	  		this.money = this.accAdd(this.pxje,2800)
	  	}else if(this.punishList.length > 5){
	  		this.money = this.accAdd(this.pxje,4800)
	  	}
	  },
	  // 删除处罚文号
	  handleDle(idex){
	  	this.punishList.splice(idex,1)
	  	
	  	if(this.punishList.length <= 1){
	  		this.money = this.accAdd(this.pxje,800)
	  	}else if(this.punishList.length > 1 &&this.punishList.length <6 ){
	  		this.money = this.accAdd(this.pxje,2800)
	  	}else if(this.punishList.length > 5){
	  		this.money = this.accAdd(this.pxje,4800)
	  	}
	  },
	  // 加法的精准度
	  accAdd(arg1, arg2) {
	    let r1, r2, m
	    try {
	      r1 = arg1.toString().split('.')[1].length
	    } catch (e) {
	      r1 = 0
	    }
	    try {
	      r2 = arg2.toString().split('.')[1].length
	    } catch (e) {
	      r2 = 0
	    }
	    m = Math.pow(10, Math.max(r1, r2))
	    return (arg1 * m + arg2 * m) / m
	  },
    alipay() {
		if(this.rad != '1'){
			this.$message({
			  showClose: true,
			  message: "请先阅读并同意服务协议再进行支付!",
			  type: "error"
			});
			return
		}


      let time = new Date();
      let randNum = "";
      for (let i = 0; i < 8; i++) {
        randNum += Math.floor(Math.random() * 10) + "";
      }
	  // 判断是否全部都满足
	  let flag = this.punishList.every(item => item.punish)
	  if(flag){
	  	this.alipayAjax(time.getFullYear() + time.format("MMddhhmmss") + randNum);
	  }else{
		   this.$message({
		            message: '请填写处罚文号',
		            type: 'warning'
		          });
	  }
      // time.getFullYear() + time.format('MMddhhmmss') + randNum
    },
     getData() {
      //首页分页
      let _self = this;
      let ajax = _self.$http.create();
      let data = {
        qyId: this.qyId,
        lxId: this.lxId
      };
      _self.loading = true;
      ajax({
        method: "get",
        url: SOWINURL + "payment/getZfmx",
        params: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
      })
        .then(function(json) {
          if (json.data.result == 1) {
            _self.pxje = json.data.data.pxje;
            _self.xybgje = json.data.data.xybgje;
            _self.zje = json.data.data.zje;
            _self.cfxx = json.data.data.cfxx;
			if(_self.punishList.length == 1){
				_self.money = _self.accAdd(_self.pxje,800)
				// console.log(this.money )
			}
            // _self.sfPxje = json.data.data.list[0].sfPxje;
            // _self.sfXyje = json.data.data.list[0].sfXyje;
            // _self.sfBkje = json.data.data.list[0].sfBkje;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
          }
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    alipayAjax(num) {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
	  let list = [];
	  this.punishList.forEach(item => {
	  	list.push(item.punish)
	  })
      ajax({
        method: "post",
        url: SOWINURL + "payment/alipay",
        data: {
          outTradeNo: num,
          lxId: this.lxId,
		  punishment:list.join(',')
        },
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
      })
        .then(function(json) {
          // console.log(json.data);
          // const zx_div = document.createElement("div");
          // zx_div.innerHTML = json.data;
          // document.body.appendChild(zx_div);
          // document.forms[0].submit();
          // loading.close();
		  if (json.data.result == 1) {
		    location.href = json.data.data;
		  } else {
		    _self.$message({
		      showClose: true,
		      message: json.data.errorcode,
		      type: "error"
		    });
		  }
		  _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped lang="less" type="text/less">
	/deep/ .el-form-item__label{
		font-size: 16px;
		color: #070d4b;
	}
	.item_name_title{
		font-size: 16px;
		color: #070d4b;
		// padding: .2rem;
		padding-bottom: 20px;
		display: flex;
		align-items: center;
	}
	.add{
		width: 42px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		font-size: 14px;
		color: #fff;
		background-color: #2287FF;
		border-radius: 4px;
		cursor: pointer;
	}
	.box_item{
		display: flex;
		align-items: center;
		padding-bottom: 20px;
	}
	.pay_to{
	padding-top: 15px;
}
.bg_lin{
	border-bottom: 1px solid #e8e8e8;
	padding-bottom: 20px;
}
.bg_box{
	width: 100%;
	height: 50px;
	line-height: 50px;

}
.left{
	float: left;
}
.right{
	float: right;
}
.status{
	width: 680px;
	margin: 0 auto;
}
.status i{
	font-style: normal;
}
.status .color_line{

	font-weight: 700;
	color: #009fe8;
	i{
		font-size: 24px;
	}
}
.pay_link{
	margin-left: 5px;
	color: #009fe8;
	font-size: 14px;
	// text-decoration: underline;
}
.check {
	width: 1180px;
  // width: 1210px;
  margin: 20px auto;
  padding-top: 130px;
  background: #fff;
  text-align: center;
  padding-bottom: 200px;
  .alipay {
    width: 177px;
    margin: 0 auto;
    background: #009fe8;
    color: #fff;
    height: 34px;
    line-height: 34px;
    margin-top: 10px;
    cursor: pointer;
  }
  .tx {
    text-align: center;
    span {
      display: inline-block;
      font-size: 14px;
      color: #0076ff;
      margin: 0 20px;
    }
  }
  .back,
  .join {
    width: 158px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 24px;
    border: 1px solid #0374ff;
    font-size: 18px;
    color: #0374ff;
    display: inline-block;
    margin: 60px 20px 0 20px;
  }

  .join {
    color: #fff;
    border: none;
    width: 160px;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    background: -webkit-linear-gradient(
      left,
      #0076ff,
      #00c9ff
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      right,
      #0076ff,
      #00c9ff
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      right,
      #0076ff,
      #00c9ff
    ); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
  }

  img {
    display: block;
    margin: 0 auto;
  }

  h3 {
    height: 90px;
    line-height: 90px;
    text-align: center;
    font-size: 30px;
    color: #02113a;
	border-bottom: 1px solid #e8e8e8;
	margin-bottom: 20px;
  }

  p {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #070d4b;
    /*margin-bottom: 100px;*/
	span{
		float: left;
	}
	i{
		float: right;
	}
  }
}
.exam {
  padding: 50px 100px;
  background: #fff;
  margin-bottom: 20px;
}
.zfmx-box{
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index_dzf.vue